"use client"

// -- Helpers --------------------------------------------------------------------------------------
const gasEstimates = {
  ethereum: 0.005,
  base: 0.000_01,
  abstract: 0.000_01,
  arbitrum: 0.000_01,
  polygon: 0.005,
  optimism: 0.000_001,
  b3: 0.000_001,
  avalanche: 0.0001,
  zora: 0.000_01,
  unichain: 0.000_001,
  solana: 0.0015,
} as Record<string, number>

const defaultGasEstimate = 0.000_001

// -- Types ----------------------------------------------------------------------------------------
type UseBaseGasPriceArgs = {
  chain?: string
  tokenAddress?: string
}

export function useBaseGasPrice({ chain, tokenAddress }: UseBaseGasPriceArgs) {
  if (!(chain && tokenAddress)) {
    return { gas: 0 }
  }

  return {
    gas: gasEstimates[chain] ?? defaultGasEstimate,
  }
}
